import React from "react";
import ServiceList from "../../models/Dealer";
import Collapsible from "../../components/Collapsible";

interface Props {
  serviceList: ServiceList[];
  departmentName: string;
}

const ServicesList = ({ serviceList, departmentName }) => {
  return (
    <div className="services-list">
      {serviceList.map(item => {
        const { serviceType, services } = item;
        return (
          <div key={`${serviceType}-${departmentName}`}>
            <Collapsible title={serviceType}>
              <ul>
                {services.length > 0 &&
                  services.map(service => {
                    const { name, toolTip } = service;
                    return (
                      <li key={name}>
                        {name}
                        {!!toolTip && (
                          <span className="tt">
                            *<span className="tt__content">{toolTip}</span>
                          </span>
                        )}
                      </li>
                    );
                  })}
              </ul>
            </Collapsible>
          </div>
        );
      })}
    </div>
  );
};

export default ServicesList;
